import React from 'react';

const IconCheckBoxFilledDisabled = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="11"
        height="11"
        rx="1.5"
        fill="#a4abb5"
        stroke="#8c96a3"
      />
      <path
        d="M4.17794 8.01478L1.80728 5.64412L1 6.44571L4.17794 9.62365L11 2.80159L10.1984 2L4.17794 8.01478Z"
        fill="#c8cdd3"
      />
    </svg>
  );
};

export default IconCheckBoxFilledDisabled;
